import React from 'react';
import '../Components/css/article.css';
import { HashLink as Link } from 'react-router-hash-link';
import { useParams } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Navbar2 from './Navbar2';
import { FiArrowLeft } from 'react-icons/fi';
import '../voices/voices-public-pages.css';

const metaData = [
    {
        id: '1',
        slug: 'how-to-keep-your-salesforce-marketing-cloud-contacts-within-the-allowed-limit',
        title: 'How to Keep your Salesforce Marketing Cloud Contacts within the Allowed Limit',
        content: `<div>
                    <p>Keeping your databases relevant under the system defined limits is crucial to
                        make best use of the data you have. And, when it comes to the data running
                        through your organization's marketing funnels, it becomes equally important to
                        maintain the rightness of the data as much as it is to cultivate it.</p>

                    <p>Approaching the above problem towards the solution is a multi-step process for
                        any such system hosting the data including Salesforce Marketing Cloud, HubSpot
                        or any other available platforms in the market because of the fact that various
                        dimensions and measures of a customer s data can be injected into the system via
                        several routes and methods that with high probability not following through a data
                        validation and matching layer.</p>
                    <p>Salesforce Marketing Cloud (SFMC) is no different and faces the similar kind of
                        challenges that we will see through the resolution process later in this article.</p>
                    <p><b>What are the possible routes of data import that SFMC has,</b></p>
                    <ul>
                        <li>Salesforce CRM connection</li>
                        <li>Direct import</li>
                        <li>API integrated external data</li>
                    </ul>
                    <p>As data grows, it is prone to evolving a number of undetected patterns (e.g.
                        missing data, duplication, data gaps etc.) that contribute to reducing the
                        effectiveness and accuracy of the data in SFMC.

                        (a thorough and detailed data analysis activity needs to be performed to identify
                        such hidden data patterns)</p>
                    <p>Once the data errors have been identified through the analysis run over it, it is a 3
                        step process to cleanup the SFMC</p>
                    <ol>
                        <li>Identify and define the SFMC data sync eligibility rules for each source</li>
                        <li>Add a layer to the source of data to push down the eligible data only.</li>
                        <li>Free up SFMC with irrelevant data</li>
                    </ol>
                    <p><b>Identify and define the SFMC data sync eligibility rules for each source</b></p>
                    <p>A few basis rules can be defined as below </p>

                    <ol>
                        <li>Customers must have a channel identified i.e. email address, phone etc.</li>
                        <li>A clear consent should have been provider</li>
                        <li>Should be eligible becoming part of the marketing initiatives</li>
                    </ol>
                    <p><b>Add a layer to the source of data to push down the eligible data only</b></p>
                    <p>If Salesforce CRM syncs data to SFMC, add a flag to all Account/Contacts/Lead
                        following the above eligibility criteria in the last step and use that flag only to be
                        syncing the records into SFMC.</p>
                    <p><b>NOTE</b>: This flag field should not be of type formula rather use a Salesforce flow to
                        update the flag running all the defined rules because formula field does not trigger
                        the CRM-SFMC connector sync.</p>
                    <p><b>Free up SFMC with irrelevant data</b></p>
                    <p>Build data extensions with the deletable records s Subscriber/Contact keys and
                        initiate SFMC deletion requests.</p>

                </div>`
    }
];

export default function Article() {
    const { name } = useParams();

    //  normalize URL (handles capital letters)
    const normalizedSlug = (name || '').toLowerCase();

    const article = metaData.find(
        item => item.slug === normalizedSlug
    );

    if (!article) {
        return <NotFound />;
    }

    return (
        <>
          <Navbar2 />
          <main className="vpp-page vpp-article" data-voices-theme="dark">
            <header className="vpp-intro">
              <h1>{article.title}</h1>
              <div className="vpp-article-byline">
                <span>By <b>Dhanna Ram</b> and <b>Yuvraj Singh Gour</b></span>
                <div><time dateTime="2024-04-21">21 April, 2024</time></div>
              </div>
            </header>
            <section className="vpp-reading-layout" data-voices-theme="dark">
              <aside className="vpp-reading-aside">
                Antrazal / Articles
                <Link to="/case-studies"><FiArrowLeft aria-hidden="true" /> All insights</Link>
              </aside>
              <article className="vpp-reading-body" dangerouslySetInnerHTML={{ __html: article.content }} />
            </section>
          

            <div className="articleSimilarNeeds">
                <div className="container">
                    <div className="articleSimilarNeedsInnerDiv">
                        <div className="articleSimilarNeedsInnerPara">
                            If you have a similar need, let's talk ...
                        </div>

                        <div className="articleSimilarNeedsInnerRightDiv">
                            <p className="articleSimilarNeedsInnerRightPara">
                                One of our consultants will reach out to you in 24 hours.
                            </p>

                            <Link
                                to="/#contact-us"
                                className="ctaButton"
                                style={{ textDecoration: 'none' }}
                            >
                                Book a meeting <span className="arrow">→</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
          </main>
        </>
    );
}
